import BaseApiAction from '@Actions/base-api-action';

export default class GetUserSessions extends BaseApiAction {
    runAction() {
        super.invokeCloudFunction({
            name: 'sessions-temp-getUserSessions',
            payload: {
                ...this.addFieldIfExists('user_id', this._payload.user_id),
                ...this.addFieldIfExists('limit', this._payload.limit),
                ...this.addFieldIfExists('offset', this._payload.offset),
                ...this.addFieldIfExists('from_date', this._payload.from_date),
                ...this.addFieldIfExists('to_date', this._payload.to_date),
                ...this.addFieldIfExists('play_position', this._payload.play_position),
                ...this.addFieldIfExists('game_mode', this._payload.game_mode),
                ...this.addFieldIfExists('session_type', this._payload.session_type),
                ...this.addFieldIfExists('is_completed', this._payload.is_completed),
                ...this.addFieldIfExists('group_by_period', this._payload.group_by_period),
                ...this.addFieldIfExists('play_session_ids', this._payload.play_session_ids)
            },
        });
    }
}
